import {
  isWindow,
  safeWindow,
} from '@sky-distribution/gp-onboarding-shared-utils';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  BannerButton,
  BannerContainer,
  BannerLink,
  BannerText,
  BannerWrapper,
} from './CookieBanner.styles';

type CookieBannerProps = {
  privacyPolicyURL?: string;
};

export const CookieBanner: FC<CookieBannerProps> = ({
  privacyPolicyURL = 'https://beesafe.pl/polityka-prywatnosci/',
}) => {
  const isCookieAccepted = safeWindow()?.localStorage?.getItem('cookieAccepted');
  const isCookieBannerHidden = !isWindow() || isCookieAccepted;
  const [isHidden, setIsHidden] = useState(isCookieBannerHidden);
  const { t } = useTranslation();

  const handleCookieAccept = (): void => {
    localStorage.setItem('cookieAccepted', 'true');
    setIsHidden(true);
  };

  if (isHidden) {
    return null;
  }

  return (
    <BannerContainer>
      <BannerWrapper>
        <BannerText>
          {t('CookieBanner.Text')}
          &nbsp;
          <BannerLink href={privacyPolicyURL}>
            {t('CookieBanner.Link')}
          </BannerLink>
        </BannerText>
        <BannerButton
          data-e2e="CookieButton"
          typeStyle="outlined"
          size="small"
          onClick={handleCookieAccept}
        >
          {t('CookieBanner.Button')}
        </BannerButton>
      </BannerWrapper>
    </BannerContainer>
  );
};
